import { DateTime } from "luxon";
import React from "react";

import { TicketPropertyRow } from "./TicketPropertyRow";

type DueDateFieldProps = {
  value: string | null;
  onChange: (dueDate: string | null) => void;
  pending?: boolean;
};

const DropdownArrow = () => (
  <svg className="h-3.5 w-3.5 text-[#707070]" viewBox="0 0 14 14" fill="none">
    <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function formatDate(dateStr: string | null): string {
  if (!dateStr) return "No date";
  return DateTime.fromISO(dateStr, { zone: "utc" }).toFormat("MM/dd/yyyy");
}

function toInputDate(dateStr: string | null): string {
  if (!dateStr) return "";
  return DateTime.fromISO(dateStr, { zone: "utc" }).toFormat("yyyy-MM-dd");
}

export function DueDateField({ value, onChange, pending }: DueDateFieldProps) {
  return (
    <TicketPropertyRow label="Due Date" pending={pending}>
      <div className="relative flex cursor-pointer items-center rounded px-2 py-0.5 hover:bg-grey-100 has-[:focus]:bg-grey-100">
        <input
          type="date"
          value={toInputDate(value)}
          onChange={(e) => onChange(e.target.value ? new Date(e.target.value).toISOString() : null)}
          className="absolute inset-0 z-10 cursor-pointer opacity-0 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-0"
        />
        <span className="flex items-center gap-2">
          <span className="text-sm text-black">{formatDate(value)}</span>
          <DropdownArrow />
        </span>
      </div>
    </TicketPropertyRow>
  );
}
